// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fo-6";
export var emphasizeQuantity = "_fo-3";
export var flatBottomCorners = "_fo-5";
export var productImage = "_fo-0";
export var quantityContainer = "_fo-2";
export var tooltip = "_fo-1";
export var wrapAndEllipsesOverflow = "_fo-4";